export interface IPublicConfig {
  BASE_API_URL: string;
  NEXT_PUBLIC_URL: string;
  AUTH0_API_URL: string;
  PUBLIC_SITE_COOKIE_DOMAIN: string;
  PUBLIC_SITE_URL: string;
  TARGET_ENV: string;
}

declare global {
  interface Window {
    __APP_CONFIG__: IPublicConfig;
  }
}

export const appConfig = (): IPublicConfig => {
  if (typeof window !== 'undefined' && window.__APP_CONFIG__?.BASE_API_URL) {
    return window.__APP_CONFIG__;
  }
  return {
    BASE_API_URL: process.env.BASE_API_URL || '',
    NEXT_PUBLIC_URL: process.env.NEXT_PUBLIC_URL || '',
    AUTH0_API_URL: process.env.AUTH0_API_URL || '',
    PUBLIC_SITE_COOKIE_DOMAIN: process.env.PUBLIC_SITE_COOKIE_DOMAIN || '',
    PUBLIC_SITE_URL: process.env.PUBLIC_SITE_URL || '',
    TARGET_ENV: process.env.TARGET_ENV || '',
  };
};
